import { render, staticRenderFns } from "./ManuscriptExportingDialog.vue?vue&type=template&id=74e87c97&scoped=true"
import script from "./ManuscriptExportingDialog.vue?vue&type=script&lang=ts"
export * from "./ManuscriptExportingDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptExportingDialog.vue?vue&type=style&index=0&id=74e87c97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e87c97",
  null
  
)

export default component.exports